export default "__VITE_ASSET__EJ7pYRa3__"